import { ChameleonElementMixin } from '../../common/mixin';
import { BreadcrumbItem } from '@microsoft/fast-components';
export class BreadcrumbItemComponent extends ChameleonElementMixin(BreadcrumbItem) {
}
